import { render, staticRenderFns } from "./hongbao.vue?vue&type=template&id=337e6abc&scoped=true"
import script from "./hongbao.vue?vue&type=script&lang=js"
export * from "./hongbao.vue?vue&type=script&lang=js"
import style0 from "./hongbao.vue?vue&type=style&index=0&id=337e6abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e6abc",
  null
  
)

export default component.exports